import React, { useState } from "react";
import { DialogBox } from "../../../../../components/Elements/DialogBox";
import { Button, Input, Checkbox, message } from "antd";
import { API_URLS } from "../../../../../api/apiUrls";
import { postApi } from "../../../../../api/api_instance";
import { THEME_COLORS } from "../../../../../color";
import { CheckOutlined } from "@ant-design/icons";
import { Modal } from "antd";
import PopupCard from "../../../../Auth/PopupCard";
const permissionsList = [
  "Dashboard",
  "Project",
  "Create Project",
  "User",
  "Create User",
  "Form Management",
];

const CreateRoles = ({ onOpen, onClose, fetchRoles }) => {
  const [roleName, setRoleName] = useState("");
  const [description, setDescription] = useState("");
  const [permissions, setPermissions] = useState({});
  const [showPopup, setShowPopup] = useState(false);
  const [popupData, setPopupData] = useState({
    type: "success",
    title: "Success",
    message: "",
  });
  const [errorMessage, setErrorMessage] = useState({
    roleName: "",
    description: "",
  });

  const handleCheckboxChange = (permission, type) => {
    setPermissions((prev) => ({
      ...prev,
      [permission]: {
        ...prev[permission],
        [type]: !prev[permission]?.[type],
      },
    }));
  };

  // const handleSave = () => {
  //   let isValid = true;
  //   const errors = { roleName: "", description: "" };

  //   if (!roleName) {
  //     errors.roleName = "Role Name is required";
  //     isValid = false;
  //   }
  //   if (!description) {
  //     errors.description = "Description is required";
  //     isValid = false;
  //   }

  //   setErrorMessage(errors);

  //   if (isValid) {
  //     console.log("Role details saved:", {
  //       roleName,
  //       description,
  //       permissions,
  //     });
  //     onClose();
  //   }
  // };
  const triggerPopup = (type, title, message, duration = 3000) => {
    setPopupData({ type, title, message });
    setShowPopup(true);
    setTimeout(() => setShowPopup(false), duration);
  };

  const handleSave = async () => {
    let isValid = true;
    const errors = { roleName: "", description: "" };

    if (!roleName.trim()) {
      errors.roleName = "Role Name is required";
      isValid = false;
    }

    if (!description.trim()) {
      errors.description = "Description is required";
      isValid = false;
    }

    setErrorMessage(errors);
    if (!isValid) return;

    const formattedPermissions = Object.entries(permissions).map(
      ([resource_name, perms]) => ({
        resource_name,
        view: perms.view || false,
        edit: perms.edit || false,
      }),
    );

    try {
      const res = await postApi({
        apiUrl: API_URLS.CREATE_ROLE,
        data: {
          name: roleName,
          description,
          permissions: formattedPermissions,
        },
      });

      if (res.success) {
        // Modal.success({
        //   icon: null,
        //   centered: true,
        //   closable: true,
        //   className: "custom-success-modal",
        //   okButtonProps: { style: { display: "none" } },
        //   content: (
        //     <div className="flex flex-col items-center text-center p-4">
        //       <div className="bg-slate-300 p-2 rounded-full">
        //         <CheckOutlined style={{ fontSize: "48px", color: "#06513D" }} />
        //       </div>

        //       <p className="text-[15px] mt-2 mb-1 font-medium">Success!</p>
        //       <h2 className="text-xl font-semibold text-[#000000]">
        //         New role added successfully.
        //       </h2>
        //     </div>
        //   ),
        // });
        triggerPopup("success", "Success", " New role added successfully");
        setTimeout(() => {
          Modal.destroyAll();
          onClose();
        }, 2000);
      } else {
        //message.error(res.message || "Failed to create role");
        triggerPopup("error", "Error", res.message || "Failed to create role");
      }
    } catch (err) {
      console.error(err);
      //message.error("Something went wrong while creating role");
      triggerPopup(
        "error",
        "Error",
        "Something went wrong while creating role",
      );
    }
  };
  const handleCancel = () => {
    setRoleName("");
    setDescription("");
    setPermissions({});
    setErrorMessage({ roleName: "", description: "" });
    onClose();
  };

  return (
    <DialogBox open={onOpen} onCancel={onClose} width="90%" maxWidth="800px">
      <div>
        <h3 className="text-xl font-bold text-[#06513D] ">
          Role & Permission (Add New)
        </h3>
      </div>

      <div className=" mt-8 ">
        <div className="flex flex-col gap-6">
          <div className=" flex flex-col gap-2">
            <label
              htmlFor="Role"
              style={{ color: THEME_COLORS.green, fontSize: "15px" }}
            >
              Role
            </label>
            <Input
              value={roleName}
              onChange={(e) => setRoleName(e.target.value)}
              placeholder="Role Name"
              className="text-base font-light h-14 rounded-lg"
            />
            {errorMessage.roleName && (
              <div className="text-red-500 text-sm">
                {errorMessage.roleName}
              </div>
            )}
            <label
              htmlFor="Description"
              style={{ color: THEME_COLORS.green, fontSize: "15px" }}
            >
              Description
            </label>
            <Input
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="Description"
              className="text-base font-light h-14 rounded-lg"
            />
            {errorMessage.description && (
              <div className="text-red-500 text-sm">
                {errorMessage.description}
              </div>
            )}
          </div>
          <div className="border rounded-lg pl-10 pr-6 pt-4 pb-8">
            <div className="flex justify-between font-light text-[#A2A1A8] text-base">
              <div className="">Permissions</div>
              <div className="flex gap-x-8">
                {" "}
                <div className="text-right ">View</div>
                <div className="text-right ">Edit</div>
              </div>
            </div>
            {permissionsList.map((permission) => (
              <div key={permission} className="flex justify-between mt-2">
                <div className="text-base pb-4 font-medium">{permission}</div>
                <div className="flex gap-x-12">
                  <div className="flex justify-center items-center">
                    <input
                      type="checkbox"
                      className="w-4 h-4 mr-2 "
                      checked={permissions[permission]?.view || false}
                      onChange={() => handleCheckboxChange(permission, "view")}
                      sx={{
                        border: "1px solid #06513D",
                        borderRadius: "4px",
                        accentColor: "#06513D",
                        padding: "4px",

                        "& .MuiSvgIcon-root": {
                          color: "#06513D", // checkbox tick color
                        },
                      }}
                      style={{
                        accentColor: "#06513D",
                      }}
                    />
                  </div>
                  <div className="flex justify-center items-center">
                    <input
                      type="checkbox"
                      className="w-4 h-4 mr-2 "
                      checked={permissions[permission]?.edit || false}
                      onChange={() => handleCheckboxChange(permission, "edit")}
                      style={{
                        accentColor: "#06513D",
                      }}
                    />
                  </div>{" "}
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="flex justify-center gap-6 p-5">
          <Button
            onClick={handleCancel}
            style={{
              background: "#E6EEEC",
              height: "40px",
              width: "120px",
              borderRadius: "10px",
              border: "1px solid #06513D",
              color: "#06513D",
              fontWeight: "bold",
            }}
            className="text-base font-normal border-none"
          >
            Cancel
          </Button>
          <Button
            onClick={handleSave}
            style={{
              background: "#06513D",
              height: "40px",
              width: "120px",
              borderRadius: "10px",
              color: "white",
            }}
            className="text-base font-normal border-none"
          >
            Save
          </Button>
        </div>
      </div>
      {showPopup && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
          <PopupCard
            type={popupData.type}
            title={popupData.title}
            message={popupData.message}
          />
        </div>
      )}
    </DialogBox>
  );
};

export default CreateRoles;
